export default __webpack_public_path__ + "static/media/USAFiance.236b3b16.jpg";